module.exports = __webpack_public_path__ + "static/media/boy.cdb7d362.png";